export default "__VITE_ASSET__13f35936__"